/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-people-tiles',
  templateUrl: './people-tiles.component.html',
  styleUrl: './people-tiles.component.scss'
})
export class PeopleTilesComponent {
  private _tiles: any = {};

  @Input()
  set tiles(value: any) {
    this._tiles = value;
  }
  get tiles(): any {
    return this._tiles;
  }
}
